// eslint-disable-next-line import/prefer-default-export
export const ECurrencyCode = Object.freeze({
  DOLLAR: "USD",
  COLON: "CRC",
  EURO: "EUR",
});
